import { AxiosResponse } from 'axios'
import { useMutation } from 'react-query'

import { previewInvoiceDraft, PreviewInvoiceDraftResponse } from '../query-api'

export interface UseGetInvoicePreviewDataProps {
  onSuccess?: (data: AxiosResponse<PreviewInvoiceDraftResponse>) => void
}

export const useGetInvoicePreviewData = ({ onSuccess }: UseGetInvoicePreviewDataProps) => {
  const { mutate: getInvoicePreviewData, isLoading, ...rest } = useMutation(previewInvoiceDraft, { onSuccess })

  return { getInvoicePreviewData, isLoading, ...rest }
}
